import logo from './logo.svg';
import './index.css';
import * as React from 'react';
import { useSearchParams, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import CreditCard from "./CreditCard.js";
import BaseUrl from "./configProvider.js";
import CardView from "./CardView.js";
import {
  Button,
  TextField,
  CircularProgress,
  FormControl,
  Box
} from '@mui/material';
import { styled } from '@mui/material/styles';

function App() {
  const [record, setRecord] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [shareId, setShareId] = useState("");
  const location = useLocation();
  const [passcode, setPasscode] = useState("");
  const [whiteLabelled, setWhiteLabelled] = useState(false);
  const [skipPasscode, setSkipPasscode] = useState(false);

  const FormDiv = styled('div')(({ theme }) => ({
    padding: '0 1em 0 1em'
  }));

  const InputDiv = styled('div')(({ theme }) => ({
    marginTop: '0'
  }));

  const IconDiv = styled('div')(({ theme }) => ({
    textAlign: 'center'
  }));

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    setShareId(id);
    const type = params.get('t');    
    
    //If type is s then it means for this client no passcode is needed.
    if(id !== "" && type === "s"){
      setSkipPasscode(true);
      setWhiteLabelled(true);
      fetchSharedDetails(id);
    }
  }, []);

  const fetchSharedDetails = (sharedCardId) => {    
    if(sharedCardId === ""){
      return;
    }

    setLoading(true);

    let payload = {
      id: sharedCardId,
      passcode: passcode
    };

    fetch(`${BaseUrl}/virtual_card_share/card-details`, {
      method: 'POST',
      headers: {
        'Content-Type': `application/json`,
        'Accept': `application/json`
      },
      body: JSON.stringify(payload),      
    })       
    .then(response =>
      response.text().then(text => ({
          status: response.status,
          statusText: response.statusText,
          headers: response.headers,
          body: text,
      }))
    )      
    .then(({ status, statusText, headers, body }) => {
        setLoading(false);

        if(status === 200 && body !== ""){ 
          setRecord(body);
          setError("");          
        } else if(status == 403) {
          setError("View limit exceeded. Please contact the sender.");
        } else {
          setError("Unable to retrieve card details. Please try again or contact the sender.");
        }          
    })
    .catch(error => {
      setLoading(false);
      //setError("Unable to retrieve card details. Please try again or contact the sender.");
    });         
  }

  return (
    <div className="App">
      <header className="App-header">      
        {!whiteLabelled && <div className='app-icon' /> }

        {loading && (
          <IconDiv>
            <CircularProgress size={18} thickness={2} />
          </IconDiv>
        )}

        {!loading && error && <div className='error'><p>Error: {error}</p></div>}

        {!loading && !error && record !== "" ? (
          <CardView record={record} />
        ) : (
          <React.Fragment>
            {!loading && !skipPasscode && (
              <Box autoComplete="off">                                
                <FormDiv>
                  <InputDiv>
                    <TextField id="txtPasscode" name="txtPasscode" label="Passcode" variant="outlined" autoFocus value={passcode} onChange={e => setPasscode(e.target.value)} required />
                  </InputDiv>
                </FormDiv>
                <br />
                <FormDiv>
                  <InputDiv>
                    <Button
                      variant="text"
                      type="submit"
                      color="primary"
                      disabled={loading}
                      className="button"
                      id="btnContinue"
                      onClick={() => fetchSharedDetails(shareId)}
                    >Submit</Button>
                  </InputDiv>
                </FormDiv>
              </Box>
            )}
          </React.Fragment>
        )
        }
      </header>
    </div>
  );
}

export default App;
